import urlPrefix from "./apiPrefix";

export const postVoucherFilter = () => `${urlPrefix.value}/tax-web-control/api/lk/voucher/filter`;
export const getVoucherFilter = () => `${urlPrefix.value}/tax-web-control/api/lk/voucher/filter`;
export const getVoucherFind = () => `${urlPrefix.value}/tax-web-control/api/lk/voucher/find`;
export const getVoucherFilterCashRegister = (regNumber: string) => `${urlPrefix.value}/tax-web-control/api/lk/voucher/filter/cash-register/${regNumber}`;
export const getShiftZReport = (key: string) => `${urlPrefix.value}/tax-web-control/api/lk/shift/z-report/${key}`;
export const getShiftXReport = (shiftId: string) => `${urlPrefix.value}/tax-web-control/api/lk/shift/x-report/${shiftId}`;
export const getShiftOpenReport = (key: string) => `${urlPrefix.value}/tax-web-control/api/lk/shift/open-report/${key}`;
